export const collapseItems = [
  {
    id: 1,
    label: "Recrutamento & Seleção",
    image: "./assets/images/collapse-image-1.png",
  },
  { id: 2, label: "RH", image: "./assets/images/collapse-image-2.png" },
  {
    id: 3,
    label: "Comercial",
    image: "./assets/images/collapse-image-3.png",
  },
  {
    id: 4,
    label: "Marketing",
    image: "./assets/images/collapse-image-4.png",
  },
  {
    id: 5,
    label: "Financeiro",
    image: "./assets/images/collapse-image-5.png",
  },
  {
    id: 6,
    label: "TI",
    image: "./assets/images/collapse-image-6.png",
  },
  {
    id: 7,
    label: "Jurídico",
    image: "./assets/images/collapse-image-7.png",
  },
  {
    id: 8,
    label: "Compras & Facilities",
    image: "./assets/images/collapse-image-8.png",
  },
];

export const stepsItems = [
  {
    label: "1. Candidatura",
    icon: "./assets/icons/proccess-icons/icon-1.svg",
  },
  { label: "2. Triagem", icon: "./assets/icons/proccess-icons/icon-2.svg" },
  {
    label: "3. Avaliação técnica e comportamental",
    icon: "./assets/icons/proccess-icons/icon-3.svg",
  },
  {
    label: "4. Entrevistas",
    icon: "./assets/icons/proccess-icons/icon-4.svg",
  },
  { label: "5. Admissão", icon: "./assets/icons/proccess-icons/icon-5.svg" },
  {
    label: "6. Integração",
    icon: "./assets/icons/proccess-icons/icon-6.svg",
  },
];

export const valuesItems = [
  {
    icon: "./assets/icons/values-icon-1.png",
    title: "conhecer",
    description:
      "Somos especialistas. Conhecemos nossos talentos, nossos clientes e nosso negócio.",
  },
  {
    icon: "./assets/icons/values-icon-2.png",
    title: "servir",
    description: "Através de um excelente atendimento, vamos além do esperado.",
  },
  {
    icon: "./assets/icons/values-icon-3.png",
    title: "confiar",
    description: "Construímos relacionamentos com nossa expertise e empatia.",
  },
  {
    icon: "./assets/icons/values-icon-4.png",
    title: "buscar a perfeição",
    description:
      "Buscamos sempre melhorar e inovar. Estamos aqui para encantar nossos clientes e talentos em tudo o que fazemos.",
  },
  {
    icon: "./assets/icons/values-icon-5.png",
    title: "promoção simultânea de todos os interesses",
    description:
      "Assumimos nossa responsabilidade social. Nosso negócio deve sempre beneficiar a sociedade como um todo.",
  },
];

export const testimonialsItems = [
  {
    img: "./assets/icons/people/people-1.png",
    name: "Renato Garrido",
    role: "Coordenador Administrativo",
    quote:
      "“Quando a experiência ultrapassa os limites da expectativa cria-se uma conexão emocional que vai além do vínculo empregado e empregador, e quem veste essa camisa torna-se OneRandstad”.",
  },
  {
    img: "./assets/icons/people/people-2.jpg",
    name: "Deisi Lins",
    role: "Analista Administrativo",
    quote:
      "Tenho imenso orgulho de pertencer à Randstad Brasil, onde me sinto verdadeiramente acolhida. Participar do grupo de afinidade de gênero me permite vivenciar de perto o incrível potencial de crescimento que a diversidade traz.  Juntos, construímos um ambiente onde cada voz é valorizada e todos podem prosperar.",
  },
  {
    img: "./assets/icons/people/people-3.png",
    name: "Erick Lima",
    role: "CIO",
    quote:
      "Eu tive uma conexão muito forte com a Randstad desde o primeiro contato. Tenho orgulho de dizer que faço parte da história no Brasil há mais de uma década, e é uma honra fazer parte da empresa que é líder global em soluções de RH, que trabalha com propósito, impactando positivamente a vida de milhares de pessoas, no Brasil e no mundo!",
  },
  {
    img: "./assets/icons/people/people-4.png",
    name: "Eliane Gomes",
    role: "Gerente de Operações",
    quote:
      "A missão da Randstad é transformar a vida das pessoas. Sinto-me muito feliz com essa missão.",
  },
  {
    img: "./assets/icons/people/people-5.png",
    name: "Iana Ferreira",
    role: "Analista de R&S",
    quote:
      "Isso é o que nos motiva! Saber que nosso trabalho faz parte do sonho de outras pessoas.",
  },
];

export const bannerItems = [
  {
    title: "faça parte de uma das",
    subtitle: "melhores empresas para",
    thirdTitle: "trabalhar no Brasil",
    description:
      "Somos reconhecidos pela GPTW desde 2020 entre as empresas com melhores práticas de desenvolvimento, gestão de pessoas e cultura organizacional, provando que o nosso trabalho coletivo está no caminho certo! E somos certificados pela Top Employer por 3 anos consecutivos, reconhecidos pelas melhores práticas de RH! Que tal fazer parte dessa jornada?",
    imageSrc: "./assets/icons/icon-banner-1.svg",
    imageBackground: "./assets/images/banner-1.png",
    imageBackgroundResponsive: "./assets/images/banner-1-responsive.png",
    buttonText: "quero fazer parte",
  },
  {
    title: "a randstad quer ser a",
    subtitle: "empresa de talentos",
    description: "mais equitativa e especializada do mundo. Vamos juntos?",
    imageSrc: "./assets/icons/icon-banner-1.svg",
    imageBackground: "./assets/images/banner-1-alternative.png",
    imageBackgroundResponsive:
      "./assets/images/banner-1-alternative-responsive.png",
    buttonText: "confira as oportunidades",
  },
];

export const benefitItems = [
  {
    icon: "./assets/icons/alternative-icons/icon-remote-work.svg",
    title: "trabalho remoto",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-previdence.svg",
    title: "previdência",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-food.svg",
    title: "vale refeição e/ou alimentação",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-medical.svg",
    title: "assistência médica e odontológica",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-birthday.svg",
    title: "day-off de aniversário",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-education.svg",
    title: "educação corporativa e programa de idiomas",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-doctor.svg",
    title: "Dr. Randstad (plataforma de assistência à saúde)",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-license.svg",
    title: "licença maternidade, licença paternidade e licença adoção",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-credit.svg",
    title: "crédito consignado",
  },
  {
    icon: "./assets/icons/alternative-icons/icon-short-friday.svg",
    title: "short friday",
  },
];
